import { Canvas } from "@react-three/fiber";
import { useGLTF, Stage, PresentationControls } from "@react-three/drei";
function Model(props) {
  // const { scene } = useGLTF(process.env.PUBLIC_URL +"/old_rusty_car.glb");
  const { scene } = useGLTF(process.env.PUBLIC_URL +"/models/old_rusty_car.glb");
  return <primitive object={scene} scale={0.01} {...props}></primitive>
}

function Car3D() {
  return (
    <Canvas dpr={[1, 2]} shadows camera={{ fov: 45 }}  >
      <color attach="background" args={["#101010"]} />
      <PresentationControls speed={1.5} global zoom={2.5} polar={[-0.1, Math.PI / 4]} >
      <Stage enviroment={null}>
        <Model scale={0.01} />
      </Stage>
      </PresentationControls>
    </Canvas>
  );
}



export default Car3D;
